
import { GeneralTip } from "@/types/ai"

interface AIGeneralTipsProps {
  tips: GeneralTip[]
}

export function AIGeneralTips({ tips }: AIGeneralTipsProps) {
  return (
    <div className="space-y-2">
      <h4 className="font-medium text-sm text-[#FFC745]">General Tips</h4>
      <div className="space-y-2">
        {tips.map((tip, index) => (
          <div key={index} className="bg-[#FFC745]/10 p-3 rounded-md border border-[#FFC745]/20">
            <h5 className="font-medium text-sm text-[#FFC745]">{tip.title}</h5>
            <p className="text-xs text-[#FFC745]/90 mt-1">{tip.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
